@let settings = settings$ | async;
@let visible = panelVisible$ | async;
@let isMobileView = isMobileView$ | async;

<div [class.active]="visible" class="accessibility-panel">
    <div class="accessibility-panel-content">
        <div class="accessibility-panel-controls">
            <div class="control-group">
                <ion-button (click)="resetSettings()" fill="clear" size="small">
                    <span class="control-label">{{ 'accessibility.reset' | translate }}</span>
                    <ion-icon class="ml-12 w-18 h-18" slot="end" src="assets/svg/refresh.svg"></ion-icon>
                </ion-button>
            </div>

            <div class="control-group">
                <ion-button (click)="toggleHighContrast()" [class.active]="settings?.isHighContrast" fill="clear" size="small">
                    <span class="control-label">
                        {{ 'accessibility.contrast' | translate }}
                    </span>
                    <ion-icon class="ml-12 w-24 h-24" slot="end" src="assets/svg/contrast.svg"></ion-icon>
                </ion-button>
            </div>

            <div class="control-group size">
                <div class="font-size-controls">
                    <label class="control-label mr-7">
                        {{ 'accessibility.font-size' | translate }}
                    </label>
                    <ion-button
                        (click)="increaseFontSize()"
                        [disabled]="(settings?.fontSize || 1) >= 1.5"
                        class="btn btn-icon-only"
                        fill="clear"
                    >
                        <ion-icon class="w-24 h-24" slot="icon-only" src="assets/svg/plus.svg"></ion-icon>
                    </ion-button>
                    <ion-button
                        (click)="decreaseFontSize()"
                        [disabled]="(settings?.fontSize || 1) <= 0.7"
                        class="btn btn-icon-only"
                        fill="clear"
                    >
                        <ion-icon class="w-24 h-24" slot="icon-only" src="assets/svg/minus.svg"></ion-icon>
                    </ion-button>
                </div>
            </div>

            <div class="control-group">
                @if (isMobileView) {
                    <ion-button (click)="hidePanel()" class="btn btn-icon-only" fill="clear">
                        <ion-icon class="w-24 h-24" slot="end" src="assets/svg/cancel.svg"></ion-icon>
                    </ion-button>
                } @else {
                    <ion-button (click)="hidePanel()" class="hide-button" fill="clear" size="small">
                        <span class="control-label">
                            {{ 'accessibility.hide-panel' | translate }}
                        </span>
                        <ion-icon class="ml-12 w-24 h-24" slot="end" src="assets/svg/cancel.svg"></ion-icon>
                    </ion-button>
                }
            </div>
        </div>
    </div>
</div>
